import { Switch } from "antd";
import React from "react";

export interface MapControlToggleProps {
  icon: React.ReactNode;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: "small" | "default";
  "data-testid"?: string;
}

/**
 * Toggle row used by the Road names and Field names controls.
 *
 * Uses antd's Switch rather than the ui-kit wrapper: the wrapper only forwards
 * `style`, `size` and `checked` to antd, so `className` and `disabled` never
 * reach the control and the panel cannot style it.
 */
const MapControlToggle: React.FC<MapControlToggleProps> = ({
  icon,
  label,
  checked,
  onChange,
  size = "small",
  "data-testid": dataTestId,
}) => (
  <div
    className={`map-control-toggle${checked ? " is-checked" : ""}`}
    data-testid={dataTestId}
  >
    <span className="map-control-icon">{icon}</span>
    <span className="map-control-label">{label}</span>
    <Switch
      className="map-control-switch"
      checked={checked}
      onChange={onChange}
      size={size}
      aria-label={label}
    />
  </div>
);

export default MapControlToggle;
